import type { FaireProductEntity } from "../../entity_types/product";

export const p_34dv9m8bpz: FaireProductEntity = {
  token: "p_34dv9m8bpz",
  type: "product",
  name: "Oversized Knit Cardigan with Buttons",
  brandToken: "b_qcqvf6ftyr",
  brandName: "AZSHOP Trading LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/a2202757b445bc15dbbf5a48c1f2a32fdd82ca19279c454113a61965e4be24da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e6cc53aa4f2ce9abd84c0fbae346f09e38d3407327c779ea1c04f1b6f4ba9610.jpeg",
    "https://cdn.faire.com/fastly/8ad8138c4819099cd0d7b06cd4bcbaff106af70c4ba9bc3fd3ba06ab23f2af16.jpeg",
    "https://cdn.faire.com/fastly/c0e4192aca0b09d584661497a896a8744f3095c1d82e49d86446e3e0f73bb172.jpeg",
    "https://cdn.faire.com/fastly/7820867f1d445b8233c84abf518773446e6c55399c798b43bed01bab0bc9e409.jpeg",
  ],
  priceDollars: 31.86,
  description:
    "An oversized cardigan with a button-front closure. Features a relaxed fit and wide sleeves for comfort. Perfect for layering on cooler days.\n\nFabric: 100% polyester\nWeight: 1.43 lb",
  tags: [],
  msrpDollars: 63.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:21.097Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
